import * as React from 'react'
import { ActionsCell } from '../LiveEvents/UpcomingEvents/ActionsCell'
import { useFormatTime } from '~/hooks/useFormatTime'

const headerMap = {
  type: 'Type',
  meeting_time: 'Date',
}

export function useCandidateNotesColumns() {
  const formatTime = useFormatTime()

  const columns = [
    {
      accessorKey: 'type',
      header: (props) => <TableHeader {...props} />,
      cell: (props) => props.row.original.title,
      enableSorting: false,
    },
    {
      accessorKey: 'meeting_time',
      header: (props) => <TableHeader {...props} />,
      cell: (props) => formatTime(props.row.original.meeting_time, 'short'),
      sortUndefined: 'last',
      sortDescFirst: true,
    },
    {
      accessorKey: 'Actions',
      header: (props) => <EmptyTableHeader {...props} />,
      cell: (props) => <ActionsCell {...props} />,
      enableSorting: false,
    },
  ]

  return columns
}

function TableHeader({ column }) {
  return <div className="font-roboto">{headerMap[column.id]}</div>
}

function EmptyTableHeader() {
  return <div className="font-roboto"></div>
}
